import React from 'react';
import FormInput from '../atoms/FormInput';

/**
 * EmergencyContactForm - Formulario de contacto de emergencia
 *
 * Props:
 * - index: Índice del contacto de emergencia (0, 1, 2...)
 * - contact: Objeto con datos del contacto {
 *     name, address, city, country, phone, relationship
 *   }
 * - onChange: Función callback (index, fieldName, value) => void
 * - errors: Objeto con errores específicos del contacto
 * - className: Clases CSS adicionales (opcional)
 */
function EmergencyContactForm({
  index,
  contact = {
    name: '',
    address: '',
    city: '',
    country: '',
    phone: '',
    relationship: 'familiar'
  },
  onChange,
  errors = {},
  className = ''
}) {
  const handleChange = (fieldName) => (e) => {
    onChange(index, fieldName, e.target.value);
  };

  const relationships = [
    { value: 'familiar', label: 'Familiar' },
    { value: 'spouse', label: 'Cónyuge' },
    { value: 'parent', label: 'Padre/Madre' },
    { value: 'sibling', label: 'Hermano/Hermana' },
    { value: 'friend', label: 'Amigo/Amiga' },
    { value: 'other', label: 'Otro' }
  ];

  return (
    <div className={`d-flex flex-column w-100 gap-4 ${className}`}>
      <div className="d-flex flex-column gap-3 py-4 px-2">
        {/* Emergency Contact Name */}
        <FormInput
          label="Nombre Completo"
          required
          placeholder="Nombre del contacto de emergencia"
          value={contact.name}
          onChange={handleChange('name')}
          error={errors.name}
        />

        {/* Address */}
        <FormInput
          label="Dirección"
          required
          placeholder="Dirección completa"
          value={contact.address}
          onChange={handleChange('address')}
          error={errors.address}
        />

        {/* City */}
        <FormInput
          label="Ciudad"
          required
          placeholder="Ciudad"
          value={contact.city}
          onChange={handleChange('city')}
          error={errors.city}
        />

        {/* Country */}
        <FormInput
          label="País"
          required
          placeholder="País"
          value={contact.country}
          onChange={handleChange('country')}
          error={errors.country}
        />

        {/* Emergency Phone */}
        <FormInput
          label="Teléfono de Emergencia"
          type="tel"
          required
          placeholder="+57 300 123 4567"
          value={contact.phone}
          onChange={handleChange('phone')}
          error={errors.phone}
        />

        {/* Relationship */}
        <div className="d-flex flex-column gap-2">
          <label className="form-label">
            Relación<span className="text-danger">*</span>
          </label>
          <select
            value={contact.relationship}
            onChange={handleChange('relationship')}
            className="form-select"
          >
            {relationships.map((rel) => (
              <option key={rel.value} value={rel.value}>
                {rel.label}
              </option>
            ))}
          </select>
          {errors.relationship && (
            <span className="text-danger small">
              {errors.relationship}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default EmergencyContactForm;
